import Vue from 'vue';

Vue.component('acceptance-designation-tabs', require('./components/acceptance-designation/Tabs').default);
Vue.component('acceptance-designation-table', require('./components/acceptance-designation/Index').default);
Vue.component('acceptance-designation-modal', require('./components/acceptance-designation/Modal').default);

Vue.component('accreditation-documents-tabs', require('./components/accreditation-documents/Tabs').default);
Vue.component('accreditation-documents-table', require('./components/accreditation-documents/Index').default);
Vue.component('document-history-index', require('./components/accreditation-documents/document-history/Index').default);
Vue.component('document-history-dat', require('./components/accreditation-documents/document-history/Document').default);

Vue.component('non-conformities-template', require('./components/non-conformities-template/Index').default);
Vue.component('non-conformities-template-edit', require('./components/non-conformities-template/Modal').default);